<template>
  <div class="background" style="height: 100vh; width: 100%">
    <div
      style="
        position: fixed;
        bottom: 0px;
        height: 50px;
        width: 100%;
        left: 0px;
        z-index: 9;
        overflow:hidden;
      "
      class="background animate__animated animate__fadeInUpBig border-t border-yellow-500 shadow-xl"
    >
      <!-- Calcucil Banner -->
      <div style="
        position: fixed;
        bottom: 0px;
        height: 50px;
        width: 100%;
        left: 0px;
        z-index: 9;
      ">
        <ins
          class="adsbygoogle"
          style="display: block"
          data-ad-client="ca-pub-5752844063568531"
          data-ad-slot="3403649078"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </div>
    <div
      class="background animate__animated animate__fadeIn"
      style="height: calc(100vh - 50px); position: relative"
    >
      <header
        class="py-2 animate__animated animate__fadeIn animate__faster w-full"
        style="position: fixed; z-index: 10"
      >
        <div class="flex items-center">
          <div class="text-left">
            <button
              class="button bg-transparent text-white"
              @click="onBackClicked()"
            >
              <span class="icon">
                <i class="fas fa-chevron-left"></i>
              </span>
            </button>
          </div>
          <div class="flex-1 text-right text-white">
            <div class="py-2 px-4 bg-transparent text-white inline-block">
              <span class="icon">
                <i class="fas fa-check text-green-300"></i>
                {{ success }}
              </span>
            </div>
            <div class="py-2 px-4 bg-transparent text-white inline-block">
              <span class="icon">
                <i class="fas fa-times text-red-300"></i>
                {{ fails }}
              </span>
            </div>
            <div class="py-2 px-4 bg-transparent text-white inline-block">
              <span class="icon">
                <i class="fas fa-stars text-yellow-300"></i>
                {{ score }}
              </span>
            </div>
            <div class="py-2 px-4 bg-transparent text-white inline-block">
              <span class="icon">
                <i class="fas fa-medal text-orange-300"></i>
                {{ record }}
              </span>
            </div>
          </div>
        </div>
      </header>
      <div style="clear: both; height: 56px"></div>

      <div class="section">
        <div class="text-center mt-12">
          <i
            class="fas fa-stopwatch text-white text-5xl animate__animated animate__pulse animate__infinite"
          ></i>
          <div
            class="m-2 font-bold text-white text-4xl"
            style="font-family: monospace"
          >
            {{ timeLeftSplited[0] }}
            <span style="opacity: 0.35">.{{ timeLeftSplited[1] }}</span>
          </div>
        </div>

        <div class="text-center mt-12">
          <div class="mt-6 font-bold text-white text-6xl">
            {{ numero1 }} + {{ numero2 }}
          </div>
          <div class="font-bold text-white text-6xl">= {{ resultado }}</div>
        </div>
      </div>

      <div
        class="section text-center"
        style="position: absolute; bottom: 0rem; width: 100%"
      >
        <div class="grid gap-2 grid-cols-2">
          <div>
            <button
              @click="onFalseClicked()"
              class="button is-large bg-red-200 w-full"
            >
              <i class="fas fa-times text-red-700 text-6xl"></i>
            </button>
          </div>
          <div>
            <button
              @click="onTrueClicked()"
              class="button is-large bg-green-200 w-full"
            >
              <i class="fas fa-check text-green-700 text-6xl"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-init",
  data() {
    return {
      timeInit: 0,
      timeLimit: 2000,
      timeLeft: 2000,
      timeLeftSplited: [0, 0],
      maxTime: 0,
      maxLevel: 0,
      coins: 0,
      record: 0,
      success: 0,
      fails: 0,
      interval: null,
      numero1: 0,
      numero2: 0,
      resultado: 0,
      playingSound: null,
      tapSound: null,
      errorSound: null,
      gameOverSound: null,
      muteSound: false,
      show: [],
    };
  },
  created: function () {
    this.startGame();
  },
  destroyed: function () {
    clearInterval(this.interval);
    this.playingSound.pause();
    this.playingSound.currentTime = 0;
  },
  methods: {
    startGame() {
      const settings = JSON.parse(
        localStorage.getItem("calcucil-settings") || "{}"
      );
      this.muteSound = settings.muteSound || false;

      const data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
      this.success = 0;
      this.fails = 0;
      this.record = data.record || 0;
      this.timeInit = new Date().getTime();
      this.timeLimit = 2000;
      this.timeLeft = 2000;
      this.maxTime = 0;
      this.show = [];

      const base = process.env.BASE_URL;

      window.introMusic =
        window.introMusic || new Audio(base + "static/sounds/intro.mp3");

      window.introMusic.pause();
      window.introMusic.currentTime = 0;

      this.playingSound =
        this.playingSound || new Audio(base + "static/sounds/playing.mp3");
      this.tapSound =
        this.tapSound || new Audio(base + "static/sounds/tap.mp3");
      this.errorSound =
        this.errorSound || new Audio(base + "static/sounds/error.mp3");
      this.gameOverSound =
        this.gameOverSound || new Audio(base + "static/sounds/game-over.mp3");

      setTimeout(() => {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }, 300);

      // this.playingSound.volume = 0.5;
      // this.playingSound.loop = true;
      // this.playingSound.play();

      clearInterval(this.interval);
      this.interval = setInterval(this.updateTime, 50);
      this.getOperation();
    },

    updateTime() {
      let restante =
        ((new Date().getTime() - this.timeLimit - this.timeInit) / 1000) * -1;
      if (restante < 0) {
        restante = 0;
      }
      let rojo = parseInt(240 - (restante / 2) * 100);
      if (rojo < 0) {
        rojo = 0;
      }
      if (rojo > 240) {
        rojo = 240;
      }
      let verde = parseInt((restante / 2) * 100);
      if (verde < 0) {
        verde = 0;
      }
      if (verde > 240) {
        verde = 240;
      }

      this.timeLeft = restante;
      if (parseInt(this.timeLeft) > this.maxTime) {
        this.maxTime = this.timeLeft;
      }
      this.timeLeftSplited = this.timeLeft.toString().split(".");
      this.timeLeftSplited[1] = (this.timeLeftSplited[1] || "0").padStart(
        3,
        "0"
      );

      if (restante === 0) {
        clearInterval(this.interval);
        this.gameOver();
      }
    },

    getOperation() {
      let restante =
        ((new Date().getTime() - this.timeLimit - this.timeInit) / 1000) * -1;
      if (restante < 2) {
        restante = 2;
      }
      let dificultad = parseInt(restante) * 5;
      dificultad = parseInt(this.success);
      if (dificultad < 10) {
        dificultad = 10;
      }
      if (dificultad > this.maxLevel) {
        this.maxLevel = dificultad;
      }
      const numero1 = Math.floor(Math.random() * dificultad + 1);
      const numero2 = Math.floor(Math.random() * dificultad + 1);
      let resultado = parseInt(numero1) + parseInt(numero2);
      if (Math.floor(Math.random() * 100) < 50) {
        resultado = numero1 + numero2;
      } else {
        resultado = Math.floor(
          Math.random() * (parseInt(resultado) + 5) +
            (parseInt(resultado) - 5 < 1 ? 1 : parseInt(resultado) - 5)
        );
      }
      this.numero1 = numero1;
      this.numero2 = numero2;
      this.resultado = resultado;
      this.score = parseInt(
        (this.success - this.fails) *
          parseInt(this.maxTime) *
          parseInt(this.maxLevel / 10)
      );
    },

    addSuccess() {
      if (!this.muteSound) {
        this.tapSound.play();
      }
      this.success = parseInt(this.success) + 1;
      this.timeLimit += 1500;
      this.getOperation();
    },

    addFail() {
      if (!this.muteSound) {
        this.errorSound.play();
      }
      device.postMessage("vibrate", [300]);
      this.fails = parseInt(this.fails) + 1;
      this.timeLimit -= 500;
      this.getOperation();
    },

    gameOver() {
      this.playingSound.pause();
      const dateSaved = JSON.parse(
        localStorage.getItem("calcucil-data") || "{}"
      );
      const data = {
        comesFromPlaying: true,
        coins: this.coins,
        record: this.record,
        success: this.success,
        fails: this.fails,
        lastAdTime: dateSaved.lastAdTime,
        maxTime: parseInt(this.maxTime),
        maxLevel: parseInt(this.maxLevel / 10),
      };
      localStorage.setItem("calcucil-data", JSON.stringify(data));
      this.$router.replace("game-over");
    },

    onTrueClicked() {
      if (this.numero1 + this.numero2 === this.resultado) {
        this.addSuccess();
      } else {
        this.addFail();
      }
    },

    onFalseClicked() {
      if (this.numero1 + this.numero2 !== this.resultado) {
        this.addSuccess();
      } else {
        this.addFail();
      }
    },

    onRetryClicked() {
      this.startGame();
    },

    onBackClicked() {
      this.$router.replace("/");
    },

    onContinueClicked() {
      this.$router.push("turno");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/02-Play.vue